export class BigQueryDatasetDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "datasetId",
            "baseName": "datasetId",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        },
        {
            "name": "selectedTables",
            "baseName": "selectedTables",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "selectedViews",
            "baseName": "selectedViews",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "labels",
            "baseName": "labels",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "overwriteExistingData",
            "baseName": "overwriteExistingData",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BigQueryDatasetDestination.attributeTypeMap;
    }
    constructor() {
    }
}
